export default "__VITE_ASSET__B2noYc$T__"